module.exports = __webpack_public_path__ + "static/media/itechlabs.57577e8a.svg";